// ---------------------------------------------------------------------------
// shared visual constants for the social widget and its tabs
// ---------------------------------------------------------------------------

// colors
export const BG = 0x1a1a24;
export const BORDER = 0x2a2a3e;
export const FIELD_BG = 0x12121a;
export const FIELD_BORDER = 0x333348;

export const LABEL_COLOR = 0x888898;
export const TEXT_COLOR = 0xf0f0ff;
export const MUTED_TEXT = 0x666678;
export const ACCENT = 0x6366f1;

export const ONLINE_COLOR = 0x22c55e;
export const OFFLINE_COLOR = 0x444455;
export const ACCEPT_COLOR = 0x22c55e;
export const REJECT_COLOR = 0xef4444;

export const COLOR_PALETTE = [
  0xd946ef, 0x6366f1, 0x06b6d4, 0x10b981, 0xeab308, 0xf97316, 0xef4444, 0x8b5cf6,
];

// layout
export const CARD_RADIUS = 6;
export const BUTTON_RADIUS = 4;
export const PADDING_X = 16;
export const PADDING_Y = 14;
export const FIELD_HEIGHT = 28;
export const FIELD_GAP = 10;
export const BUTTON_HEIGHT = 30;
export const BUTTON_GAP = 8;

// typography
export const LABEL_SIZE = 10;
export const TEXT_SIZE = 12;
export const FONT = "system-ui, sans-serif";
export const RESOLUTION = 3;

// tab bar
export const TAB_HEIGHT = 28;
export const TAB_FONT_SIZE = 11;
export const TAB_ACTIVE_COLOR = ACCENT;
export const TAB_INACTIVE_COLOR = MUTED_TEXT;

// friend list rows
export const ROW_HEIGHT = 44;
export const ROW_HEIGHT_BIO = 52;
export const ROW_PADDING_X = 10;
export const ROW_AVATAR_SIZE = 24;
export const ROW_NAME_SIZE = 12;
export const ROW_SUB_SIZE = 10;
export const ROW_ALT_BG = 0x1e1e2a;
export const SCROLL_SPEED = 20;

// drag-and-drop
export const DRAG_HOLD_MS = 150;
export const DRAG_THRESHOLD = 5;
export const GHOST_ALPHA = 0.65;
export const DRAG_ROW_DIMMED_ALPHA = 0.3;

// drop zone bar (shown during drag)
export const DROP_ZONE_HEIGHT = 36;
export const DROP_ZONE_BG = 0x252540;
export const DROP_ZONE_ACTIVE_BG = 0x3a3a5a;
export const DROP_ZONE_BORDER = 0x4a4a6a;
export const DROP_ZONE_FONT_SIZE = 11;

// group header drop target highlight
export const GROUP_LINE_WIDTH = 3;
export const GROUP_LINE_INSET = 2;
export const HEADER_HOLD_MS = 400;

// online dot
export const ONLINE_DOT_SIZE = 7;
export const ONLINE_DOT_BORDER = 2;

// request rows
export const REQUEST_ROW_HEIGHT = 52;
// taller variant used when a row also shows a truncated bio line (mirrors
// ROW_HEIGHT/ROW_HEIGHT_BIO's relationship above)
export const REQUEST_ROW_HEIGHT_BIO = 66;
export const ACTION_BTN_SIZE = 24;

// settings
export const SETTINGS_ROW_HEIGHT = 16;
export const OPTION_PILL_HEIGHT = 26;
export const OPTION_PILL_RADIUS = 13;
export const OPTION_PILL_GAP = 6;
export const OPTION_FONT_SIZE = 10;

// profile tab — avatar
export const AVATAR_RADIUS = 36;
export const AVATAR_EXPORT_SIZE = 100;

// color picker dots
export const COLOR_DOT_RADIUS = 7;
export const COLOR_DOT_GAP = 4;
/** left inset for the color-dot row so the selection ring (drawn at
 *  `COLOR_DOT_RADIUS + 3`, 2px stroke) doesn't overhang past the row's
 *  own x=0 and get clipped by the profile tab's scroll mask (a real
 *  user-reported bug, 2026-07-03: ring cut off on the left side). */
export const COLOR_RING_INSET = 4;

// profile tab — "my canvases" list
export const PROFILE_CANVAS_ROW_HEIGHT = 40;
export const PROFILE_CANVAS_SWATCH_SIZE = 12;
